import * as React from 'react';

import classNames from 'classnames';
import type { ISizeModifier } from '../SizeHelper';
import { getSizeModifierClasses } from '../SizeHelper';

interface IFieldLabelProps extends ISizeModifier {
	className?: string;
}

export default class FieldLabel extends React.Component<IFieldLabelProps, {}> {
	public render() {
		const { className } = this.props;

		const classes = classNames(
			'field-label',
			getSizeModifierClasses(this.props),
			className ? className : ''
		);

		return <div className={classes}>{this.props.children}</div>;
	}
}
